import React from 'react';
import { Typography } from '@mui/material';

const ParagraphContent = ({ item, index, sectionTextColor }) => {
    //console.log("ParagraphContent item:", item, "index:", index, "sectionTextColor:", sectionTextColor);
    return (
        <Typography
            key={index}
            className="game-section-paragraph"
            sx={{
                fontSize: item.fontSize || '16px',
                fontWeight: item.fontWeight || '500',
                textAlign: item.textAlign || 'left',
                marginBottom: item.marginBottom || '16px',
                color: item.textColor || sectionTextColor
            }}
        >
            {item.text}
        </Typography>
    );
};

export default ParagraphContent;